export const formSubmmitMapper = (data) => ({
  id_kategori_anggaran: data?.idKategori,
  nama_kategori_anggaran: data?.namaKategori,
  keterangan: data?.keterangan,
});
